module.exports = __webpack_public_path__ + "img/pethouse04.4a75b2a1.jpg";